import { useQuery, } from "@tanstack/react-query";
import { PaymentsListView, } from "./PaymentsListView.tsx";
import { upcomingPaymentsQueryConfig, } from "../../../api";

export function PaymentsListDefault() {
  const payments = useQuery(upcomingPaymentsQueryConfig(),);
  const paymentsData = payments.data ?? [];

  return (
    <PaymentsListView
      isLoading={payments.isLoading}
      isSuccess={payments.isSuccess}
      data={paymentsData}
    />
  );
}
